import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { RequiresWiderScreen } from '@/components/requires-wider-screen'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { LoanLink } from '@/features/loans/loan-link'
import { loanPaths } from '@/features/loans/loan-paths'
import { LOAN_PERMISSIONS, useLoanPermissions } from '@/features/loans/permissions'
import { ClassificationSchemeForm } from '@/features/loans/scheme-form'

/**
 * Putting a classification scheme into force.
 *
 * Configuration, countersigned, and the thing that decides what the institution reports as
 * non-performing and how much it holds against every facility. It refuses a narrow display for
 * the reason the mobile policy gives about configuration: rarely urgent, permanently
 * consequential — and a band table is not readable on a phone in any case.
 */
export function ClassificationSchemeNewPage() {
  const permissions = useLoanPermissions()

  return (
    <RequiresWiderScreen
      screen="Putting a classification scheme into force"
      reason="It decides what the institution reports as non-performing and what it holds against every facility."
    >
      <LoanLink
        to={loanPaths.portfolio}
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        Back to the portfolio
      </LoanLink>

      <PageHeader
        title="New classification scheme"
        description="Bands in days overdue, and the provision each of them requires. In force from a date, never retrospectively."
      />

      {permissions.canConfigureClassification ? (
        <ClassificationSchemeForm />
      ) : (
        <Alert tone="warning">
          <AlertTitle>Your role cannot configure classification</AlertTitle>
          <AlertDescription>
            This needs{' '}
            <span className="font-mono text-xs">{LOAN_PERMISSIONS.classificationConfig}</span>, and
            a second person holding{' '}
            <span className="font-mono text-xs">
              {LOAN_PERMISSIONS.classificationConfigApprove}
            </span>{' '}
            to countersign it.
          </AlertDescription>
        </Alert>
      )}
    </RequiresWiderScreen>
  )
}
